/**
 * @generated SignedSource<<a52ebcd06a4aa831dac52b8597ca3675>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedYMALItemsCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_user">;
  readonly " $fragmentType": "PdpSharedYMALItemsCarousel_user";
};
export type PdpSharedYMALItemsCarousel_user$key = {
  readonly " $data"?: PdpSharedYMALItemsCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedYMALItemsCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedYMALItemsCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedProductTileCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c4fa75b381b66cb67ab37204168fffe5";

export default node;
